import React from "react";
import { Grid } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import AdSystemBudgetBox from "../elements/AdSystemBudgetBox";
import CreditsDashboardBox from "../elements/Credits/CreditsDashboardBox";
import DashboardTabs from "../elements/DashboardTabs";
import WizardHeader from "../elements/WizardHeader";
import { AdSystemT, FeatureFlagT } from "../graphql/generated/graphql";
import { useFeatureFlag } from "../hooks/useFeatureFlag";

export const Dashboard = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Dashboard Page" });
  const [activeTab, setActiveTab] = React.useState("dashboard");
  const tabsRef = React.useRef<HTMLDivElement>(null);

  const { enabled: hasMetaCampaignsEnabled } = useFeatureFlag(FeatureFlagT.MetaCampaignsT);

  const navigateToAssetsTab = (tabId: string) => {
    setActiveTab(tabId);
    setTimeout(() => {
      tabsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };

  const navigateToRecommendations = () => {
    setActiveTab("dashboard");
    setTimeout(() => {
      document.getElementById("product-recommendations")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  };

  return (
    <div>
      <WizardHeader showBackToDashboardButton={false} />
      <h1 data-test-id="dashboard-page">{t("Headline")}</h1>
      <CreditsDashboardBox />
      <div style={{ margin: "24px 0" }}>
        <Grid columns={hasMetaCampaignsEnabled ? 2 : 1}>
          <AdSystemBudgetBox
            adSystem={AdSystemT.GoogleAdsT}
            onNavigateToAssets={() => navigateToAssetsTab("assets-google")}
            onNavigateToRecommendations={navigateToRecommendations}
          />
          {hasMetaCampaignsEnabled && (
            <AdSystemBudgetBox
              adSystem={AdSystemT.MetaAdsT}
              onNavigateToAssets={() => navigateToAssetsTab("assets-meta")}
            />
          )}
        </Grid>
      </div>
      <div ref={tabsRef}>
        <DashboardTabs activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
    </div>
  );
};
